export default "__VITE_ASSET__BqZcsrMf__"